module.exports = __webpack_public_path__ + "media/ganbatte.36176633.mp3";